// KWANKGM04320_近代化資金借入申込結果確認
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Heading from '../../molecules/Heading';
import Reception from '../../templates/Reception';
import { mp_flg as mp_flg_value } from '../../Const';
import MypageReturn from '../../molecules/MypageReturn';
import LoadingModal from '../../molecules/LoadingModal';
import ReceptionResult from '../../templates/ReceptionResult';
import { StepNavigation as StepType } from '../../types/Template';
import ShowModernizationFundButton from '../../molecules/ShowModernizationFundButton';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import ShowBusinessImprovementFinancingPlanButton from '../../molecules/ShowBusinessImprovementFinancingPlanButton';
import FooterModernisationFundingConfirmationResults from '../../organisms/FooterModernisationFundingConfirmationResults';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  reception_id: number;
  status_code: number;
  guarantors_num: number;
  is_loading: boolean;
  display_status: boolean;
  show_error_nav: boolean;
  guarantor_info: GuarantorInfo;
  review_approval_status: boolean; // 審査結果が「承認」か
  review_approval_status_name: string; // 事前審査結果
  review_message: string; // お客様へのお知らせ
  mp_flg: number; // 借入申込希望書兼経営改善資金計画書フラグ
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  callApi: (function_name: string) => Promise<any>;
  moveNextStep: () => void;
}

const ModernisationFundingConfirmationResults: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  reception_id,
  status_code,
  guarantors_num,
  is_loading,
  display_status,
  show_error_nav,
  guarantor_info,
  review_approval_status,
  review_approval_status_name,
  review_message,
  mp_flg,
  moveNextStep,
  setParentShelfs,
  setChildShelfs,
  setContents,
  callApi,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />

      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />

      {/* 審査結果アコーディオン */}
      <ReceptionResult
        review_approval_status_name={review_approval_status_name}
        review_message={review_message}
        is_open={true}
      />

      {/* お申込情報 */}
      <Heading size="m" label="お申込情報" />
      {/* 『借入申込希望書兼経営改善資金計画書』ボタン表示 */}
      {(mp_flg === mp_flg_value.completion ||
        mp_flg === mp_flg_value.loan_approval_has_been_coordinated) && (
        <ShowBusinessImprovementFinancingPlanButton status_code={status_code} />
      )}
      {/* 『借入申込書』ボタン表示 */}
      <ShowModernizationFundButton status_code={status_code} />

      {/* 『契約申込に進む』ボタン表示 */}
      {/* ※審査結果が承認の場合のみ表示 */}
      {review_approval_status && (
        <FooterModernisationFundingConfirmationResults
          reception_cd={reception_cd}
          reception_id={reception_id}
          status_code={status_code}
          moveNextStep={moveNextStep}
        />
      )}

      <LoadingModal show={is_loading} />
      <MypageReturn is_staff={false} />
    </>
  );
};

export default ModernisationFundingConfirmationResults;
